import { IColorFields } from '@/types/contentful';
import get from 'lodash/get';
import { GreenlightThemeOptions } from 'src/theme/themes/greenlight';

function contentfulColorToHexColor({ colorToken, hexOverride }: IColorFields) {
  if (hexOverride) {
    return hexOverride;
  }

  if (colorToken) {
    // Color Token is hyphen-tokenized in contenful, so lets dot it for lodash.
    return (
      get(GreenlightThemeOptions.COLORS, colorToken.replaceAll('-', '.')) ??
      '#000000'
    );
  }

  return '#000000';
}

export default contentfulColorToHexColor;
